module.exports = __webpack_public_path__ + "img/inactive-sprint.4868bcea.svg";